<div class="window" [ngStyle]="customWindowStyles">
  @if (displayConfiguration.displayReceiverSender) {
    <div class="receiver-sender">
      <div class="receiver">
        <ng-container *ngIf="participantOrganization; else NoParticipant">
          <ng-container *ngIf="currentUser?.organization?.id === program?.sponsor?.id; else InvestorName">
            {{ participantOrganization?.name }}
          </ng-container>
          <ng-template #InvestorName>
            {{ program?.sponsor?.name }}
          </ng-template>
        </ng-container>
        <ng-template #NoParticipant>
          {{ 'program.message.no-participant' | translate }}
        </ng-template>
      </div>
      <div class="sender">{{ currentUser?.organization?.name }}</div>
    </div>
  }

  @if (displayConfiguration.displayMessagesList) {
    <div class="messages"
         #messageViewPort
         [ngClass]="{'no-participant': !participantOrganization}"
         [scrollTop]="scrollTop">
      <ng-container *ngIf="participantOrganization; else NoParticipantMessage">
        <div class="message-group">
          <ng-container *ngFor="let message of messages">
            <div
              class="message"
              [ngClass]="{
              right: currentUser?.organization?.id === message.sender?.organization?.id,
              left: currentUser?.organization?.id !== message.sender?.organization?.id
            }">
              <div class="message-container">
                <div class="bubble" (click)="downloadFile(message.documentId)"
                     [ngClass]="{ 'file-bubble' : message.type === 'API_FILE' }">
                  <ng-container *ngIf="message.type === 'API_FILE'; else UserMessage">


                    <div class="d-flex">
                      <img style="width: 13px; margin-right: 9px" src="assets/icons/line-icons/shared/black/attach.svg"
                           role="presentation" />
                      <div class="body" *ngFor="let path of message?.message?.split(',');">
                        {{ getFileNameFromPath(path) }}
                      </div>
                    </div>


                  </ng-container>
                  <ng-template #UserMessage>
                    <div class="body" [innerHtml]="message.message | safeHtml"></div>
                  </ng-template>
                </div>
                <div class="date">
                  {{ message.sentDateTime | date:'dd-MMM-yyyy HH:mm' }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="reload">
          <button type="button"
                  class="btn btn-circle btn-secondary"
                  (click)="reload()"
                  placement="left"
                  tooltip="{{'buttons.reload' | translate}}">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>
        </div>
      </ng-container>
      <ng-template #NoParticipantMessage>
        <oes-notify
          [message]="'program.message.participant-is-not-selected' | translate"
          [type]="'warning'"
          [iconName]="'fa-exclamation'">
        </oes-notify>
      </ng-template>
    </div>
  }

  @if (displayConfiguration.displayStatusSelector) {
    <oes-status-dropdown
      label="program.message.application-status"
      [statuses]="statuses()"
      [programApplication]="programApplication"
      (onStatusChange)="onStatusChange($event)"
    />
  }

  <div class="command">
    <form class="section" [formGroup]="formGroup" (ngSubmit)="sendAll()">

      <oes-quill
        [characterLimit]="8000"
        formControlName="body"
        [option]="option"
        [style]="{height: '155px'}"
        [placeholder]="'program.message.send-message' | translate">
      </oes-quill>

      <div class="action-buttons">
        <div class="file-uploader">
          <label for="upload-button">
            <img style="width: 18px;" src="assets/icons/line-icons/shared/black/attach.svg" role="presentation" />
          </label>
          <input
            type="file"
            (change)="changeInput($event)"
            id="upload-button"
            style="display: none;">
        </div>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!participantOrganization || formGroup?.invalid || (!hasStatusChanged() && !(formGroup?.controls?.body?.value?.textControl?.length > 0))"
          title="Send">
          <img style="width: 18px;" src="assets/icons/line-icons/shared/white/send.svg" role="presentation" />
          {{ 'buttons.send' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
